// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._19-0 {\n  width: 100%;\n}\n\n._19-0 > * {\n    width: 100%;\n  }\n\n._19-1 {\n  width: 100%;\n  overflow-y: auto;\n  outline: none;\n}\n", ""]);
// Exports
export var childrenContainer = "_19-0";
export var virtualScrollArea = "_19-1";
export default ___CSS_LOADER_EXPORT___;
